// scroll to anchor position fix due to header overflow

function hashRefresh() {
  if (window.location.hash) {
    properScrollTo(window.location.hash);
  }
}

function properScrollTo(hash) {
  const pureHash = hash.replace('#','');
  const targetBlock = document.getElementById(pureHash);

  if (targetBlock) {
    const targetBlockTop = targetBlock.offsetTop;

    setTimeout(function () {
      window.scrollTo(0, targetBlockTop - 50);
    }, 100);
  }
}

function hasClass(elem, searchedClass) {
  return elem[0].className.match(new RegExp('(\\s|^)' + searchedClass + '(\\s|$)'));
}

function insertAfter(referenceNode, newNode) {
  referenceNode[0].parentNode.insertBefore(newNode, referenceNode[0].nextSibling);
}

function setProgressBarWidth () {
  const progressBar = document.getElementsByClassName("js-progress-bar");
  const scrollHeight = document.documentElement.scrollHeight;
  const scrollPosition = (window.pageYOffset || document.documentElement.scrollTop);
  const windowHeight = window.innerHeight;

  progressBar[0].style.width = ( scrollPosition / ( scrollHeight - windowHeight ) * 100 ) + '%';
}

document.addEventListener('DOMContentLoaded', function() {
  hashRefresh();

  const header = document.getElementsByClassName("site-header-main");
  const progressBar = document.createElement("div");
  progressBar.className += 'js-progress-bar';

  if (hasClass(document.getElementsByTagName("body"), "single")) {
    insertAfter(header, progressBar);
    setProgressBarWidth();
  };
});

window.onscroll = function() {
  const progressBar = document.getElementsByClassName("js-progress-bar");

  if (progressBar.length) {
    setProgressBarWidth();
  }
};

window.addEventListener("hashchange", hashRefresh, false);
